import { isWeb, tva } from "@gluestack-ui/utils/nativewind-utils";

const baseStyle = isWeb
  ? "flex relative z-0 box-border border-0 list-none min-w-0 min-h-0 bg-transparent items-stretch m-0 p-0 text-decoration-none"
  : "";

export const hstackStyle = tva({
  base: `flex-row ${baseStyle}`,
  variants: {
    space: {
      "2xs": "gap-0.5",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-4",
      xl: "gap-5",
      "2xl": "gap-6",
      "3xl": "gap-7",
      "4xl": "gap-8",
    },
    reversed: {
      true: "flex-row-reverse",
    },
    flexSpace: {
      xs: "[&>*]:pl-1 [&>*]:pt-1 flex-wrap -ml-1 -mt-1",
      sm: "[&>*]:pl-2 [&>*]:pt-2 flex-wrap -ml-2 -mt-2",
      md: "[&>*]:pl-3 [&>*]:pt-3 flex-wrap -ml-3 -mt-3",
      lg: "[&>*]:pl-4 [&>*]:pt-4 flex-wrap -ml-4 -mt-4",
      xl: "[&>*]:pl-5 [&>*]:pt-5 flex-wrap -ml-5 -mt-5",
      "2xl": "[&>*]:pl-6 [&>*]:pt-6 flex-wrap -ml-6 -mt-6",
      "3xl": "[&>*]:pl-7 [&>*]:pt-7 flex-wrap -ml-7 -mt-7",
      "4xl": "[&>*]:pl-8 [&>*]:pt-8 flex-wrap -ml-8 -mt-8",
    },
  },
});
